import { render, staticRenderFns } from "./applyOrderDetail.vue?vue&type=template&id=24d78cac&scoped=true&"
import script from "./applyOrderDetail.vue?vue&type=script&lang=js&"
export * from "./applyOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./applyOrderDetail.vue?vue&type=style&index=0&id=24d78cac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d78cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d78cac')) {
      api.createRecord('24d78cac', component.options)
    } else {
      api.reload('24d78cac', component.options)
    }
    module.hot.accept("./applyOrderDetail.vue?vue&type=template&id=24d78cac&scoped=true&", function () {
      api.rerender('24d78cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/publicizeMaterialManagement/applyOrderDetail.vue"
export default component.exports